export const pageSizes = [
  { value: 10, name: 10, label: '10' },
  { value: 20, name: 20, label: '20' },
  { value: 30, name: 30, label: '30' },
  { value: 40, name: 40, label: '40' },
  { value: 50, name: 50, label: '50' },
];
